// Специальные редакционные метки; обычные теги новостей не определяют направление.
export const directionNewsTags = {
  robotics: 'lisad-robotics',
  ai: 'lisad-ai',
  electronics: 'lisad-electronics',
  software: 'lisad-software',
} as const;

export type DirectionId = keyof typeof directionNewsTags;

export const achievementNewsTag = 'achievements';

export const directionNewsTagOptions: ReadonlyArray<{ id: DirectionId; label: string; slug: string }> = [
  { id: 'robotics', label: 'Робототехника', slug: directionNewsTags.robotics },
  { id: 'ai', label: 'Искусственный интеллект', slug: directionNewsTags.ai },
  { id: 'electronics', label: 'Электроника', slug: directionNewsTags.electronics },
  { id: 'software', label: 'Программные системы', slug: directionNewsTags.software },
];

export function isDirectionNewsTag(value: string): boolean {
  return directionNewsTagOptions.some(option => option.slug === value);
}

export function isEditorialNewsTag(value: string): boolean {
  return isDirectionNewsTag(value) || value === achievementNewsTag;
}

export function getNewsTagLabel(value: string): string {
  if (value === achievementNewsTag) return 'Достижения';
  return directionNewsTagOptions.find(option => option.slug === value)?.label || value;
}

export function toggleDirectionNewsTag(tags: readonly string[], direction: DirectionId): string[] {
  const slug = directionNewsTags[direction];
  return tags.includes(slug) ? tags.filter(tag => tag !== slug) : [...tags, slug];
}

export function toggleAchievementNewsTag(tags: readonly string[]): string[] {
  return tags.includes(achievementNewsTag)
    ? tags.filter(tag => tag !== achievementNewsTag)
    : [...tags, achievementNewsTag];
}
